export default __webpack_public_path__ + "static/media/circle_img.c991d919.png";